import { getTransferTypes } from '@/services/files.service';
import { getProviders } from '@/services/providerFiles.service';
import { normalizeResults } from '@/utils/utils';


const Model = {
  namespace: 'providerFilesNew',

  state: {
    providers: [],
    transferTypes: [],
    providersLoading: false,
    transferTypesLoading: false,
  },

  effects: {
    *fetchTransferTypes(_, { call, put }) {
      yield put({ type: 'setData', payload: { transferTypesLoading: true } });
      try {
        const response = yield call(getTransferTypes);
        const data = Array.isArray(response.data) ? response.data : [];
        yield put({
          type: 'setData',
          payload: {
            transferTypes: data.filter((item) => item?.enabled !== false),
            transferTypesLoading: false,
          },
        });
      } catch {
        yield put({ type: 'setData', payload: { transferTypesLoading: false } });
      }
    },

    *searchProviders({ payload }, { call, put }) {
      yield put({ type: 'setData', payload: { providersLoading: true } });
      try {
        const response = yield call(getProviders, {
          search: payload?.search,
          provider_type: 'TOURISM_AGENCY',
        });
        yield put({
          type: 'setData',
          payload: { providers: normalizeResults(response.data), providersLoading: false },
        });
      } catch {
        yield put({ type: 'setData', payload: { providersLoading: false } });
      }
    },
  },

  reducers: {
    setData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

export default Model;
